import {
	Component,
	ElementRef,
	HostListener,
	OnInit,
	ViewChild
} from '@angular/core';

import { Title } from '@angular/platform-browser';


import {
	ActiveDatasModel,
	Dd1pndsNgFooterContentService,
	Dd1pndsNgHeaderService,
	Dd1pndsNgInitAppService,
	Dd1pndsNgPopinsService
} from 'dd1pnds-ngx-libs';

import {
	Dd1pndsNgRedirectionService,
	Dd1pndsNgToldService,
	ExtranauteModel,
	HttpReponseAuthService,
	HttpReponseParamsMaintenanceService,
	HttpReponseParamsSiteService,
	IsConnectModel

} from 'dd1pnds-ngx-services';

import {
	FooterContentModel
} from 'dd1pnds-ngx-libs/lib/ui/dd1pnds-ng-footer/dd1pnds-ng-footer.model';

import {
	HeaderContentModel
} from 'dd1pnds-ngx-libs/lib/ui/dd1pnds-ng-header/dd1pnds-ng-header.model';

import {
	ICON_IDS
} from './configs/app.config';

import {
	MappingEventRedirection,
	MappingEventRedirectionExterieur
} from './configs/mapping-event-redirection.enum';

import {
	RoutesConfig
} from './configs/routes.config';

import {
	AvvcCmsService
} from './shared/services/avvc-cms/avvc-cms.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html'
})

export class AppComponent implements OnInit {

	@ViewChild('titleBlock') titleBlock: ElementRef;
	@ViewChild('footer', { read: ElementRef }) footer: ElementRef;
	@ViewChild('header', { read: ElementRef }) headerElement: ElementRef;

	headerAppContent: HeaderContentModel;
	footerAppContent: FooterContentModel;
	isLogged: IsConnectModel;
	extranaute: ExtranauteModel;
	contentLink: string;
	pageTitle: string;
	windowScrolled: boolean;
	windowScrolledBottom: boolean;
	cmsContentLoaded = false;
	activeDatas: ActiveDatasModel;
	isSiteDispo: boolean;
	isSiteIndispo: boolean;

	// all pages of the app.
	tabUrlTemplate = [
		RoutesConfig.routeNames.accueil
	];

	readonly iconFile = 'iconFile';

	constructor(
		private appRoutingService: Dd1pndsNgRedirectionService,
		private footerService: Dd1pndsNgFooterContentService,
		private headerService: Dd1pndsNgHeaderService,
		private initAppService: Dd1pndsNgInitAppService,
		private httpReponseAuthService: HttpReponseAuthService,
		private httpReponseParamsMaintenanceService: HttpReponseParamsMaintenanceService,
		private httpReponseParamsSiteService: HttpReponseParamsSiteService,
		private popinsService: Dd1pndsNgPopinsService,
		private avvcCmsService: AvvcCmsService,
		private toldService: Dd1pndsNgToldService,
		private titleService: Title) {
	}

	ngOnInit(): void {
		Promise.all([
			this.httpReponseParamsSiteService.paramsSiteRequest(), // This request is needed to load all site parameters.
			this.httpReponseParamsMaintenanceService.getIsSiteDispo()
		]).then(
			// we don't care of the first element.
			([, isSiteDispo]) => {
				this.isSiteDispo = isSiteDispo;
				this.isSiteIndispo = !this.isSiteDispo;

				if (this.isSiteDispo) {
					this.appRoutingService.initNavigationConfig(MappingEventRedirection, MappingEventRedirectionExterieur, 'avvc');
					this._initPageContent();
					this.toldService.startTold();
				}
			}, error => {
				console.error('La récupération des params-site a rencontré un problème : ' + error.message);
			}
		);
	}

	/**
	 * Listens to page scrolling and set windowScrolled and windowScrolledBottom values.
	 */
	@HostListener('window:scroll', [])
	onWindowScroll(): void {
		if (this.isSiteDispo) {
			const footerElementRect = this.footer.nativeElement.getBoundingClientRect();
			this.windowScrolled = (window.scrollY > 0);
			this.windowScrolledBottom = (footerElementRect.top <= window.innerHeight && footerElementRect.top > 0);
		}
	}

	/**
	 * Gets user session status and redirect page according to that.
	 * @param eventName - Contain status used to redirect page
	 */
	redirectPage(eventName: string): void {
		// true (last param) to redirect on this app after a FC connexion.
		this.initAppService.redirectPage(eventName, this.headerAppContent, RoutesConfig.routeNames, MappingEventRedirection, true);
	}

	/**
	 * Scrolls to the 'start' of the header, with a 'smooth' behavior.
	 */
	backtoTop(): void {
		this.initAppService.backtoTop(this.headerElement);
	}

	/**
	 * Redirects to the path set through the CONNEXION_COOKIE.
	 */
	private _initPageContent(): void {
		this.avvcCmsService.loadAppCmsData().subscribe({
			next: () => {
				this._initPropertiesValues();
				this.popinsService.setCookiesPopinContent(this.avvcCmsService.getPopinCookiesContent());
				this.initAppService.initCookiesPopin();
			},
			error: (error) => {
				console.error('Error on header and footer content load : ', error);
				this.headerAppContent = this.headerService.getHeaderContent();
				this.footerAppContent = this.footerService.getFooterContent();
			},
			complete: () => {
				this.cmsContentLoaded = true;
			}
		});
	}

	/**
	 * Initializes header/footer of main component with data from CMS and handle user session management.
	 */
	private async _initPropertiesValues(): Promise<void> {
		this.contentLink = 'Contenu';

		this.initAppService.saveIcons(ICON_IDS, this.iconFile);

		this.pageTitle = this.titleService.getTitle();

		this._loadHeaderAndFooterContentFromCms();

		// 0 pour "accueil"
		// 1 pour "vos services"
		// 2 pour "évenements de vie"
		this.activeDatas = this.initAppService.listenRouteChange(this.headerAppContent, this.tabUrlTemplate, 1);

		this.httpReponseAuthService.getEventIsConnectSubject().subscribe({
			next: (data) => {
				this.isLogged = data;
			},
			error: (error) => {
				console.error(error.message);
			}
		});

		this.extranaute = await this.initAppService.isUserConnect(this.headerAppContent, RoutesConfig.routeNames, MappingEventRedirection);
	}

	/**
	 * Retrieves the CMS for header and footer and call the default one if error.
	 */
	private _loadHeaderAndFooterContentFromCms(): void {
		this.headerAppContent = this.avvcCmsService.getHeaderContent();
		this.footerAppContent = this.avvcCmsService.getFooterContent();
	}
}
